import React from 'react';
import HeaderSeven from '../../components/Header/HeaderFive';
import Footer from '../../components/Footer/FooterThree';
import SkillMain from './SkillMain';

const SkillLab = () => {
  return (
    <>
      <HeaderSeven />
      <SkillMain />
      <Footer />
    </>
  );
};

export default SkillLab
;
